import Home from '../../pages/home';

export const route: {
	name: string;
	path: string;
	exact: boolean;
	component: typeof Home;
} = {
	name: 'HOME',
	path: '/',
	exact: true,
	component: Home,
};
